import DefaultLayout from 'layouts/DefaultLayout/DefaultLayout';
import './faculties__list.scss';
import React, { useEffect, useRef, useState } from 'react';
import { $api } from 'services/service';
import { useDispatch } from 'react-redux';
import { setAlert, setLoading } from 'redux/authSlice';
import { useHistory } from 'react-router-dom';
import ErrorDialog from 'components/Elements/ErrorDialog/ErrorDialog';
import Calendar from '../../../components/Elements/Calender/Calendar';
import { useParams } from 'react-router';
import TableSubjectTeachingRoom from '../../../components/Elements/Table/TableSubjectTeachingRoom';
import Button from '../../../components/Elements/Button/Button';

import { Modal } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment/moment';

function SubjectRoom() {
    let history = useHistory();
    const ref = useRef();
    const dispatch = useDispatch();
    // @ts-ignore
    const { fId, cId } = useParams();
    const [subjectOnDay, setSubjectOnDay] = useState([]);
    const [viewType, setViewType] = useState('default');
    const [dateStr, setDateStr] = useState('');
    const [freeTextSearch, setFreeTextSearch] = useState('');
    const [errDialog, setErrDialog] = useState({ isOpen: false, subTitle: '' });
    const [isMonth, setIsMonth] = useState({
        start: new Date(),
        end: new Date()
    });
    const [calendarSubject, setCalendarSubject] = useState([{
        id: '',
        title: '',
        start: '',
        end: '',
        backgroundColor: '#1e3a8a',
        eventName: 'subject'
    }]);
    const [subjectTeaching, setSubjectTeaching] = useState({
        id: '',
        subjectId: '',
        name: '',
        startDate: new Date(),
        endDate: new Date(),
        startTime: '00:00',
        teacherId: '',
        roomIdDefault: ''
    });

    const [modalShowEditSchedule, setModalShowEditSchedule] = useState(false);
    const [editingSchedule, setEditingSchedule] = useState(null);
    const [timeInput, setTimeInput] = useState({
        startTime: '08:00',
        endTime: '11:30'
    });


    const [subjectScheduleExport, setSubjectScheduleExport] = useState(
        {
            startDate: new Date(),
            endDate: new Date(new Date().setMonth(new Date().getMonth() + 6)),
            classId: cId
        }
    );
    const [rooms, setRooms] = useState([]);

    useEffect(() => {
        getSubjectOnDate(new Date());
    }, [viewType]);

    const handleEditSchedule = (scheduleData) => {
        if(scheduleData.examId) return;
        const startDate = new Date(scheduleData.startDateTime);
        const endDate = new Date(scheduleData.endDateTime);
        setEditingSchedule({
            ...scheduleData,
            startDate,
            endDate
        });
        // Parse the date and time from the schedule data
        setTimeInput({
            startTime: moment(startDate).format('HH:mm'),
            endTime: moment(endDate).format('HH:mm')
        });

        setModalShowEditSchedule(true);
    };

    const handleUpdateSchedule = async () => {
        try {
            dispatch(setLoading(true));

            // Prepare updated data
            const updatedData = {
                id: editingSchedule.subjectScheduleId,
                startDateTime: moment(`${moment(editingSchedule.startDate).format('YYYY-MM-DD')}T${timeInput.startTime}:00`)
                    .subtract(7, 'hours')
                    .format('YYYY-MM-DDTHH:mm:ss'),
                endDateTime: moment(`${moment(editingSchedule.endDate).format('YYYY-MM-DD')}T${timeInput.endTime}:00`)
                    .subtract(7, 'hours')
                    .format('YYYY-MM-DDTHH:mm:ss'),
                roomId: editingSchedule.roomId
            };


            // Call API to update
            const res = await $api.schedule.subjectSchedule_update(updatedData);

            if (res) {
                // Refresh data
                getSubjectOnDate(dateStr);
                setModalShowEditSchedule(false);
                // Show success message
                dispatch(
                    setAlert({
                        title: res.message
                    })
                );
            }

            dispatch(setLoading(false));
        } catch (e) {
            dispatch(setLoading(false));
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    };


    async function getSubjectOnDate(dateStr) {
        try {
            dispatch(setLoading(true));
            const res: any = await $api.schedule.subjectSchedules_GetOptionSchedule({
                'date': dateStr,
                'freeTextSearch': freeTextSearch,
                'isWeekDisplay': viewType == 'week'
            });
            if (res && res.result) {
                const arraySubject = [];
                if (res.result) {
                    setSubjectOnDay(res.result);
                    // @ts-ignore
                    ref.current.scrollIntoView({
                        behavior: 'smooth',
                        block: 'nearest',
                        inline: 'start'
                    });
                    setDateStr(dateStr);
                } else {
                    setSubjectOnDay([]);
                }
                dispatch(setLoading(false));
            }
        } catch (e) {
            dispatch(setLoading(false));
            // show_ErrMsg(e?.response?.data?.errors?.exceptionMessage ? e?.response?.data?.errors?.exceptionMessage.title : 'Đã có lỗi xảy ra, xin vui lòng thử lại');
            let errMsg;
            let type = typeof e?.response?.data?.errors?.exceptionMessage;
            if (type === 'string') {
                errMsg = e?.response?.data?.errors?.exceptionMessage;
            } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
            } else {
                errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
            }
            show_ErrMsg(errMsg);
        }
    }

    useEffect(() => {
        setCalendarSubject([{
            id: '',
            title: '',
            start: '',
            end: '',
            backgroundColor: '#1e3a8a',
            eventName: 'subject'
        }]);
        setSubjectScheduleExport({ ...subjectScheduleExport, classId: cId });
    }, [isMonth]);

    useEffect(() => {
        async function getTeachers() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.teacher.getAll();
                if (res.result.length !== 0) {
                    subjectTeaching.teacherId = res.result[0].id;
                    setSubjectTeaching({
                        ...subjectTeaching
                    });
                } else {
                    setSubjectTeaching({
                        ...subjectTeaching,
                        teacherId: ''
                    });
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        async function getRooms() {
            try {
                dispatch(setLoading(true));
                const res: any = await $api.room.getAll();
                if (res['result'].length !== 0) {
                    setRooms(res.result);
                    setSubjectTeaching({
                        ...subjectTeaching,
                        roomIdDefault: res.result[0].id
                    });
                } else {
                    setSubjectTeaching({
                        ...subjectTeaching,
                        roomIdDefault: ''
                    });
                }
                dispatch(setLoading(false));
            } catch (e) {
                dispatch(setLoading(false));
                let errMsg;
                let type = typeof e?.response?.data?.errors?.exceptionMessage;
                if (type === 'string') {
                    errMsg = e?.response?.data?.errors?.exceptionMessage;
                } else if (e?.response?.data?.errors?.exceptionMessage?.title) {
                    errMsg = e?.response?.data?.errors?.exceptionMessage?.title;
                } else {
                    errMsg = 'Đã có lỗi xảy ra, xin vui lòng thử lại';
                }
                show_ErrMsg(errMsg);
            }
        }

        getRooms();
        getTeachers();
    }, []);


    function show_ErrMsg(msg) {
        setErrDialog({
            isOpen: true
            , subTitle: msg
        });
    }


    // @ts-ignore
    return (
        <DefaultLayout>
            <div className='subject page mb-0'>
                <div className='page__header'>
                    <div className='___title flex items-center'>
                        <div className='___title__decorate' />
                        <div>Thời khóa biểu phòng</div>
                    </div>
                </div>
                <div className='page__content bg-white mt-3'>
                    <div className='actions flex items-center  justify-between'>
                        <div className='flex justify-between w-full'>
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                    Chế độ xem
                                </div>
                                <select
                                    className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                    value={viewType}
                                    onChange={(e) => {
                                        setViewType(() => e.target.value);
                                    }}>
                                    <option
                                        value={'default'}>
                                        Xem theo ngày
                                    </option>
                                    <option
                                        value={'week'}>
                                        Xem theo tuần
                                    </option>
                                </select>
                            </div>
                            <div className={'actions flex justify-end align-bottom h-100 mt-4'}>
                                <input
                                    name='search'
                                    type='text'
                                    required
                                    className='mr-4 w-80 input-custom appearance-none block
								 	px-3 py-2 border border-gray-300
									placeholder-gray-500 rounded-md
									focus:outline-none focus:ring-1
									focus:ring-blue-700'
                                    placeholder={
                                        'Tìm kiếm theo phòng '
                                    }
                                    value={freeTextSearch}
                                    onChange={(e) => setFreeTextSearch(e.target.value)}
                                    onKeyDown={(e) =>
                                        e.key === 'Enter' && getSubjectOnDate(dateStr)
                                    }
                                />
                                <div onClick={() => getSubjectOnDate(dateStr)}>
                                    <Button
                                        label='Tìm kiếm'
                                        color='bg-yellow-500'
                                        hoverColor='bg-yellow-400'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='page__content bg-white mt-3'>
                    <Calendar
                        aspectRatio={3}
                        data={calendarSubject}
                        isEventClicked={id => {
                        }}
                        isEventDateClicked={dateStr => getSubjectOnDate(dateStr)}
                        isEventChangeMonthClicked={(startStr, endStr) => setIsMonth({
                            start: startStr,
                            end: endStr
                        })}
                    />
                </div>
                {
                    // @ts-ignore
                    <div className='page__content bg-white mt-3' ref={ref}>
                        {
                            // @ts-ignore
                            <TableSubjectTeachingRoom
                                data={subjectOnDay}
                                onEditClick={handleEditSchedule}
                            />
                        }
                    </div>
                }
            </div>

            <Modal
                show={modalShowEditSchedule}
                aria-labelledby='contained-modal-title-vcenter'
                onHide={() => setModalShowEditSchedule(false)}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title id='contained-modal-title-vcenter'>
                        Chỉnh sửa lịch học
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editingSchedule && (
                        <div>
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    Môn học: {editingSchedule.subjectName}
                                </div>
                            </div>
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    Lớp: {editingSchedule.subjectTeachingName}
                                </div>
                            </div>
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    Giảng viên: {editingSchedule.teacherName}
                                </div>
                            </div>
                            {/*<div className='mt-2'>*/}
                            {/*    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>*/}
                            {/*        Phòng: {editingSchedule.roomName}*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {rooms && rooms.length > 0 ? (
                                <div className='mt-2'>
                                    <div className='pl-1 text-sm font-semibold mb-2 text-gray-600 '>
                                        Phòng học
                                    </div>
                                    <select
                                        className='input-custom block
												w-100 px-3 py-2 border border-gray-300
												placeholder-gray-500 rounded-md
												focus:outline-none focus:ring-1
												focus:ring-blue-700'
                                        // @ts-ignore
                                        value={editingSchedule.roomId}
                                        onChange={(e) => {
                                            setEditingSchedule({
                                                ...editingSchedule,
                                                roomId: e.target.value
                                            });
                                        }}>
                                        {rooms.map((item: any) => {
                                            return (
                                                <option
                                                    value={item.id}
                                                    key={item.id}>
                                                    {item.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            ) : (
                                ''
                            )}
                            <div className='mt-2'>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    Ngày học
                                </div>
                                <DatePicker
                                    className='appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700'
                                    selected={editingSchedule.startDate ? new Date(editingSchedule.startDate) : new Date(editingSchedule.startDateTime)}
                                    onChange={(date) => {
                                        setEditingSchedule({
                                            ...editingSchedule,
                                            startDate: date,
                                            endDate: date
                                        });
                                    }}
                                    dateFormat='dd/MM/yyyy'
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    <div className={'flex flex-row justify-between'}>
                                        <div>Giờ bắt đầu</div>
                                        <div>
                                            <button className={'btn btn-sm bg-blue-800 text-white mr-1'}
                                                    onClick={() => setTimeInput({
                                                        ...timeInput,
                                                        startTime: '08:00',
                                                        endTime: '11:30'
                                                    })}>Buổi SA
                                            </button>
                                            <button className={'btn btn-sm bg-yellow-500 text-white mr-1'}
                                                    onClick={() => setTimeInput({
                                                        ...timeInput,
                                                        startTime: '13:30',
                                                        endTime: '16:45'
                                                    })}>Buổi CH
                                            </button>
                                            <button className={'btn btn-sm bg-green-500 text-white'}
                                                    onClick={() => setTimeInput({
                                                        ...timeInput,
                                                        startTime: '17:00',
                                                        endTime: '20:00'
                                                    })}>Buổi TỐI
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <input
                                    name='text'
                                    type='time'
                                    required
                                    className='appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700'
                                    placeholder='Giờ bắt đầu buổi học'
                                    value={timeInput.startTime}
                                    onChange={(e) => {
                                        setTimeInput({
                                            ...timeInput,
                                            startTime: e.target.value,
                                            endTime: e.target.value == '08:00' ? '11:30' : e.target.value == '13:30' ? '16:45' : timeInput.endTime
                                        });
                                    }}
                                />
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <div className='pl-1 text-sm font-semibold mb-2 text-gray-600'>
                                    Giờ kết thúc
                                </div>
                                <input
                                    name='text'
                                    type='time'
                                    required
                                    className='appearance-none block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700'
                                    min={timeInput.startTime}
                                    value={timeInput.endTime}
                                    onChange={(e) => {
                                        setTimeInput({
                                            ...timeInput,
                                            endTime: e.target.value
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <div className='flex flex-row justify-between w-100'>
                        <div
                            onClick={() => {
                                setModalShowEditSchedule(false);
                            }}>
                            <Button color={'bg-red-600'} hoverColor={'bg-red-800'}
                                    icon={<i className='fas fa-times-circle'></i>} label='Hủy' />
                        </div>
                        <div
                            onClick={handleUpdateSchedule}>
                            <Button icon={<i className='fas fa-save'></i>}
                                    label={'Lưu lại'} />
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
            <ErrorDialog
                errorDialog={errDialog}
                setErrorDialog={setErrDialog}
            />
        </DefaultLayout>
    );
}


export default SubjectRoom;
